module.exports = __webpack_public_path__ + "static/media/bg-dog-collar-preta.00094898.webp";